import { boolean, InferType, number, object, string } from "yup";

import { LabelConstants } from "@assets/constants";
import { NaNToNull } from "@assets/helpers/validationHelpers";

import { ErrorTranslation, InputConstraint } from "../constants";

// --- Response schemas ---

export const domesticPriceAddressSchema = object().shape({
  value: string().required(),
  label: string().required(),
  defaultAddress: string().required(),
});

export type DomesticPriceAddress = InferType<typeof domesticPriceAddressSchema>;

export const priceResultSchema = object().shape({
  Amount: number().required().min(-1),
});

export type PriceResult = InferType<typeof priceResultSchema>;

// --- Form schema ---
export const createCalculatorFormSchema = () =>
  object().shape({
    Departure: object()
      .nullable()
      .required(LabelConstants.ERROR_LABELS.REQUIRED_FIELD),

    Arrival: object()
      .nullable()
      .required(LabelConstants.ERROR_LABELS.REQUIRED_FIELD)
      .test(
        "not-same-area",
        ErrorTranslation.SAME_LOCATION,
        function (arrival: DomesticPriceAddress | null | undefined) {
          const departure: DomesticPriceAddress | null = this.parent.Departure;

          if (!arrival || !departure) return true;

          return arrival.defaultAddress !== departure.defaultAddress;
        }
      ),

    Weight: number()
      .nullable()
      .transform(NaNToNull)
      .typeError(LabelConstants.ERROR_LABELS.REQUIRED_FIELD)
      .required(LabelConstants.ERROR_LABELS.REQUIRED_FIELD)
      .min(
        InputConstraint.MIN_INPUT_WEIGHT,
        LabelConstants.ERROR_LABELS.GREATER_THAN_N
      )
      .max(
        InputConstraint.MAX_INPUT_WEIGHT,
        LabelConstants.ERROR_LABELS.MAX_N_EXCEEDED
      ),

    Volume: number()
      .nullable()
      .transform(NaNToNull)
      .typeError(LabelConstants.ERROR_LABELS.REQUIRED_FIELD)
      .required(LabelConstants.ERROR_LABELS.REQUIRED_FIELD)
      .min(
        InputConstraint.MIN_INPUT_VOLUME,
        LabelConstants.ERROR_LABELS.GREATER_THAN_N
      )
      .max(
        InputConstraint.MAX_INPUT_VOLUME,
        LabelConstants.ERROR_LABELS.MAX_N_EXCEEDED
      ),

    IsDangerous: boolean().optional(),
    IsFragile: boolean().optional(),
    IsTemperatureControlled: boolean().optional(),
    UseCompany: boolean().optional(),
  });
